import { FC } from "react";
import { useAppSelector } from "../../../../../../../../../../../store/hooks";
import { PrevPeriodCostColumnHeaderCell } from "../../../../../../../../../resource-explorer/components/resource-explorer-card/components/resource-explorer-data-grid/components/columns/components/common/PrevPeriodCostColumnHeaderCell";
import { costBreakdownV2WidgetSetupPrevTotalCostSelector } from "../../../../../../../../../../../store/dashboards/selectors/widgets/cost-breakdown-v2/setup/costBreakdownV2WidgetSetupPrevTotalCostSelector";

export const CostBreakdownV2WidgetSetupTablePrevTotalCostHeaderCell: FC =
  () => {
    const previousPeriodTotal = useAppSelector(
      costBreakdownV2WidgetSetupPrevTotalCostSelector,
    );

    return (
      <PrevPeriodCostColumnHeaderCell
        sum={previousPeriodTotal?.cost ?? 0}
        dateDetails={previousPeriodTotal?.dateDetails}
      />
    );
  };
